import React, { Component } from 'react';
import { View, Button, Modal, Spinner, PageContainer, Card, Loc } from '../UIElements/All.js';
import { Colors, ModalColors, ButtonColors } from '../Managers/ThemeManager';

import { getRewards, getOneTimeRewards, getQualifiedDiscounts, addRewardToSale } from '../Managers/NetworkManager';
import { addRewardRedemption, setPageTitles, close } from '../Managers/LSLoyaltyAPI';
import { pop } from '../Managers/AppActions';
import { isRetail, pts, points } from '../Managers/Utils';

var LocalizationManager = require('../Managers/LocalizationManager.js');
export default class RedeemReward extends Component {
  constructor(props) {
    super(props);

    var state = this.props.location.state;
    if( typeof state.allRewards === 'undefined' ) state.allRewards = [];
    state.isUpdating = true;
    this.state = state;
  }

  componentDidMount()
  {
	LocalizationManager.localizedStringForKey("REDEEM_REWARD_PAGE_TITLE", [], (retrievedString)=>
	{
		setPageTitles("asf", retrievedString, "asdf");
	});  
  	this.setRewards(this.state.rewards, this.state.oneTimeRewards, this.state.qualifiedDiscounts);

  	this.updateRewards();
  }

  componentDidUpdate(prevProps, prevState)
  {
  	if( typeof this._didAttemptQRReward !== 'undefined' && this._didAttemptQRReward ) return;

  	if( typeof this.state.qrCode.rewardID !== 'undefined' && this.state.allRewards.length > 0  )
  	{
  		this._didAttemptQRReward = true;
  		for( var i = 0; i < this.state.allRewards.length; i++ )
  		{
  			var reward = this.state.allRewards[i];
  			if( reward.RewardID == this.state.qrCode.rewardID )
  			{
  				this.rewardSelected(reward)
  				break;
  			}
  		}
  	}
  }

  updateRewards()
  {
  	var self = this;
	getQualifiedDiscounts(this.state.user.UserID, this.state.user.Hash, "app", this.state.receipt, this.state.urlInputs).then((result)=>
	{ 
		getRewards(self.state.user.UserID, self.state.user.Hash, self.state.urlInputs).then((rewards)=>
		{
			getOneTimeRewards(self.state.user.UserID, self.state.user.Hash, self.state.urlInputs).then((oneTimeRewards)=> self.setRewards(rewards, oneTimeRewards, result.QualifiedDiscounts))			
		})
	})
  }

  setRewards(rewards = [], oneTimeRewards = [], qualifiedDiscounts = [])
  {
  	var allRewards = [];
  	for( var i = 0; i < rewards.length; i++ )
	{
	  	var affordedReward = false;
		var reward = rewards[i];
		for( var j = 0; j < qualifiedDiscounts.length; j++ )
	  	{
	  		var discount = qualifiedDiscounts[j];
	  		if( reward.RewardID == discount.RewardID )
			{
				affordedReward = true;
				if( typeof reward.Discount !== 'undefined' )
				{
					if( reward.Discount < discount.Discount ) reward.Discount = discount.Discount;
				}
				else reward.Discount = discount.Discount;

				if( typeof discount.CurrentDiscountAmount !== 'undefined' && discount.CurrentDiscountAmount != 0 ) reward.CurrentDiscountAmount = discount.CurrentDiscountAmount;
				if( typeof discount.CurrentDiscountPercentage !== 'undefined' && discount.CurrentDiscountPercentage != 0 ) reward.CurrentDiscountPercentage = discount.CurrentDiscountPercentage;
				if( typeof discount.ItemName !== 'undefined' && discount.ItemName != 0 ) reward.ItemName = discount.ItemName;
			}
	  	}

	  	reward.Afforded = affordedReward;
	  	allRewards.push(reward);
	}

	for( var i = 0; i < oneTimeRewards.length; i++ )
	{
		var affordedReward = false;
		var reward = oneTimeRewards[i];
		for( var j = 0; j < qualifiedDiscounts.length; j++ )
	  	{
	  		var discount = qualifiedDiscounts[j];
	  		if( reward.RewardID == discount.RewardID )
			{
				affordedReward = true;
				if( typeof reward.Discount !== 'undefined' )
				{
					if( reward.Discount < discount.Discount ) reward.Discount = discount.Discount;
				}
				else reward.Discount = discount.Discount;
				
				if( typeof discount.CurrentDiscountAmount !== 'undefined' && discount.CurrentDiscountAmount != 0 ) reward.CurrentDiscountAmount = discount.CurrentDiscountAmount;
				if( typeof discount.CurrentDiscountPercentage !== 'undefined' && discount.CurrentDiscountPercentage != 0 ) reward.CurrentDiscountPercentage = discount.CurrentDiscountPercentage;
				if( typeof discount.ItemName !== 'undefined' && discount.ItemName != 0 ) reward.ItemName = discount.ItemName;
			}
	  	}

	  	reward.Afforded = affordedReward;
	  	allRewards.push(reward);
	}

	allRewards = allRewards.sort((a, b)=>
	{
		if( a.Afforded != b.Afforded ) return b.Afforded - a.Afforded
		if( a.Points == b.Points ) return a.RewardName.localeCompare(b.RewardName)
		if( typeof a.Points === 'undefined' && typeof b.Points !== 'undefined' ) return -1
		if( typeof b.Points === 'undefined' && typeof b.Points !== 'undefined' ) return 1
		if( typeof b.Points === 'undefined' && typeof b.Points === 'undefined' ) return a.RewardName.localeCompare(b.RewardName)
		return a.Points - b.Points
	})

	this.setState({rewards, oneTimeRewards, allRewards, qualifiedDiscounts, isUpdating:rewards.length <= 0})
  }

  rewardSelected(reward)
  {
  	var self = this;
  	if( reward.Afforded )
  	{

		
		var title = <Loc locKey="REDEEM_REWARD_PAGE_TITLE" ></Loc>; //  "Redeem Reward";
		var message = <Loc locKey="REDEEM_REWARD_STATEMENT" locParams={[reward.RewardName]}></Loc>;  //"Redeem " + reward.RewardName + "?";
		if( typeof reward.CurrentDiscountAmount !== 'undefined' )
		{
			message = 
			<View style={{flexDirection:'column',alignSelf:'stretch', textAlign:'left', justifyContent:'center'}}>
				<View>
					<Loc locKey="REPLACE_DISCOUNT_ITEM_STATEMENT" locParams={[reward.ItemName]}></Loc>
				</View> {/* "Replace current discount on "+reward.ItemName + "?" */}
				<View style={{padding:8}}>
					<Loc locKey="CURRENT_DOLLAR_OFF_STATEMENT" locParams={[typeof reward.CurrentDiscountAmount !== 'undefined' ? parseFloat(reward.CurrentDiscountAmount).toFixed(2) :  "" ]}></Loc>
				</View> {/*"Current: $" + parseFloat(reward.CurrentDiscountAmount).toFixed(2) + " off" */}
				<View style={{padding:8}}>
					<Loc locKey="NEW_PRICE_STATEMENT" locParams={[parseFloat(reward.Discount).toFixed(2)]}></Loc>
				</View>{/*"New: $" + parseFloat(reward.Discount).toFixed(2) + " off"*/}
			</View>;
			title = <Loc locKey="REPLACE_CURRENT_DISCOUNT_TITLE"></Loc>
		}
		else if( typeof reward.CurrentDiscountPercentage !== 'undefined' )
		{
			message = 
			<View style={{flexDirection:'column',alignSelf:'stretch', textAlign:'left', justifyContent:'center'}}>
				<View>
					<Loc locKey="REPLACE_DISCOUNT_ITEM_STATEMENT" locParams={[reward.ItemName]}></Loc>
				</View>
				<View style={{padding:8}}>
					<Loc locKey="CURRENT_PERCENTAGE_OFF_STATEMENT" locParams={[typeof reward.CurrentDiscountPercentage !== 'undefined' ? (100 * reward.CurrentDiscountPercentage).toFixed(1) : "" ]}></Loc>
				</View>
				<View style={{padding:8}}>
					<Loc locKey="NEW_PRICE_STATEMENT" locParams={[parseFloat(reward.Discount).toFixed(2)]}></Loc>
				</View>
			</View>;
			title = <Loc locKey="REPLACE_CURRENT_DISCOUNT_TITLE"></Loc>
		}
		else if( typeof reward.Points !== 'undefined' && reward.Points > 0 )
		{
			message = <Loc locKey="REDEEM_REWARD_FOR_POINTS_STATEMENT" locParams={[(typeof reward.Points !== 'undefined' ?  reward.Points : ""), reward.RewardName  ]}></Loc>
		}

		self._pageContainer.getModal().showAlertWithParams(title, null, message, null, ["NO_BUTTON", typeof reward.Points === 'undefined' ? "YES_BUTTON" : "USE_POINTS_BUTTON"], [[], [typeof reward.Points === 'undefined' ? "": reward.Points]], [()=>
		{
			self._pageContainer.getModal().hide();
		}, ()=>
		{
			self._pageContainer.getModal().showSpinner("REDEEMING_REWARD_SPINNER");
			addRewardToSale(self.state.user.UserID, self.state.user.Hash, reward.RewardID, self.state.qrCode.type, self.state.urlInputs).then((result)=>
			{
				if( isRetail() )
				{
					self._pageContainer.getModal().hide();
					close(self.state.urlInputs);
				}
				else
				{
					addRewardRedemption(reward.RewardName, reward.Discount, result.TransactionID, self.state.user.UserID, self.state.user.Hash, self.state.qrCode.type).then(()=>
					{
						self._pageContainer.getModal().hide();
						pop(self);
					})	  				
				}
			})
		}])
		
  	}
  	else
  	{
  		if( parseFloat(reward.Points) > parseFloat(this.state.user.Points) )
  		{
			self._pageContainer.getModal().showAlert("INSUFFICIENT_POINTS_ALERT_TITLE", "INSUFFICIENT_POINTS_ALERT_BODY2", ["OKAY_BUTTON"], [()=>
			{
				self._pageContainer.getModal().hide();
			}])
  		}
  		else
  		{
			self._pageContainer.getModal().showAlert("ELIGIBLE_ITEM_ALERT_TITLE", "ELIGIBLE_ITEM_ALERT_BODY", ["OKAY_BUTTON"], [()=>
			{
				self._pageContainer.getModal().hide();
			}])
  		}
  	}
  }

  render() 
  {
  	var self = this;

    return (
      <PageContainer ref={(a) => { this._pageContainer = a; }} urlInputs={this.state.urlInputs}>
      	<Card>
	      	<View style={{flex:-1, margin:10, flexDirection:'column'}}>
  				<View style={{flex:-1, margin:4, alignItems:'center', flexDirection:'column'}}>
      				<View style={{flex:1, fontSize:44}}>
      					{this.state.user.Points}
      				</View>
      				<View style={{flex:1, fontSize:14, marginTop:4, color:Colors.label1}}>
						<Loc locKey="POINTS_CAPITALS_CONTEXTUAL" locParams={[this.state.user.Points]}></Loc>
      				</View>
					</View>
  			</View>
      	</Card>
      	{
      		isRetail() ?
      		<View style={{flex:-1, alignSelf:'stretch', flexDirection:'column'}}>
	      		<Card title="SELECT_REWARD_TITLE" style={{marginTop:20, flexDirection:'column'}}>
			      	<View style={{alignSelf:'stretch', flexDirection:'column', minHeight:10, justifyContent:'flex-start'}}>
					{
			      		this.state.allRewards.map((reward, index)=>
			      		{
				      		return <View key={reward.RewardID} style={{flex:-1, alignSelf:'stretch', flexDirection:'column', opacity:reward.Afforded ? 1 : .4}}>
				      			<Button type={3} colors={ButtonColors} style={{flex:-1, flexDirection:'row', height:-1, width:-1, borderRadius:0, borderWidth:0}} onPress={()=>self.rewardSelected(reward)}>
				      				<View style={{flex:-1, width:8, height:100}}>
				      				</View>
				      				<View style={{flex:1, flexDirection:'column', alignItems:'flex-start', justifyContent:'center', padding:8}}>
				      					<View style={{flex:-1, height:30, fontSize:18, alignItems:'center', justifyContent:'center', color:Colors.table1Text1}}>
						      				{reward.RewardName}
				      					</View>
				      					<View style={{flex:-1, textAlign:'left', fontSize:14, alignItems:'flex-start', justifyContent:'flex-start', color:Colors.table1Text2, wordWrap: "break-word"}}>
						      				{reward.Description}
				      					</View>
				      				</View>
				      				{
				      					typeof reward.Points !== 'undefined' ?
					      					<View style={{flex:-1, color:Colors.table1Text1, alignSelf:'center', fontSize:22, padding:10}}>
											  	<Loc locKey="PTS_CONTEXTUAL" locParams={[reward.Points]}></Loc>
						      				</View>
				      					: null
				      				}
				      			</Button>
				      			{
				      				index != self.state.allRewards.length-1 ?
				      					<View style={{alignSelf:'stretch', flex:-1, height:2, backgroundColor:Colors.table1Divider}} />
				      				: null
				      			}
				      		</View>
			      		})
			      	}
			      	</View>
		      	</Card>
		      	<Button onPress={()=>
		  		{
		  			pop(self);
		  		}} type={1} colors={ButtonColors} style={{alignSelf:'center', margin:12}}>
				   	<Loc locKey="BACK_BUTTON"></Loc>
		      	</Button>
		    </View>
      		:
      		<View style={{flex:11, alignItems:'stretch', overflow:'hidden', alignSelf:'stretch', flexDirection:'column', justifyContent:'center'}}>
		      	<View style={{position:'relative', overflowY:'auto', alignSelf:'stretch', flex:1, backgroundColor:Colors.table1Background, margin:12, flexDirection:'column', justifyContent:'flex-start'}}>
		      		<View style={{flex:1, overflow: "auto", "-webkit-overflow-scrolling": "touch", alignSelf:'stretch', flexDirection:'column', justifyContent:'flex-start'}}>
		      			<View style={{alignSelf:'stretch', minHeight: "-webkit-min-content", flexDirection:'column', justifyContent:'flex-start'}}>
		      			{
				      		this.state.allRewards.map((reward, index)=>
				      		{
					      		return <View key={reward.RewardID} style={{flex:-1, alignSelf:'stretch', flexDirection:'column', opacity:reward.Afforded ? 1 : .4}}>
					      			<Button type={3} colors={ButtonColors} style={{flex:-1, flexDirection:'row', height:-1}} onPress={()=>self.rewardSelected(reward)}>
					      				<View style={{flex:-1, width:8, height:100}}>
					      				</View>
					      				<View style={{flex:1, flexDirection:'column', alignItems:'flex-start', justifyContent:'center', padding:8}}>
					      					<View style={{flex:-1, height:30, alignItems:'center', justifyContent:'center', color:Colors.table1Text1}}>
							      				{reward.RewardName}
					      					</View>
					      					<View style={{flex:-1, textAlign:'left', alignItems:'flex-start', justifyContent:'flex-start', color:Colors.table1Text2, wordWrap: "break-word"}}>
							      				{reward.Description}
					      					</View>
					      				</View>
					      				{
					      					typeof reward.Points !== 'undefined' ?
						      					<View style={{flex:-1, color:Colors.table1Text1, alignSelf:'center', fontSize:32, padding:10}}>
											  		<Loc locKey="PTS_CONTEXTUAL" locParams={[reward.Points]}></Loc>
							      				</View>
					      					: null
					      				}
					      			</Button>
					      			<View style={{alignSelf:'stretch', flex:-1, height:2, backgroundColor:Colors.table1Divider}} />
					      		</View>
				      		})
				      	}
				      	</View>
		      		</View>
		      	{
		      		this.state.isUpdating ?
		      			<View style={{position:'absolute', top:0, left:0, bottom:0, right:0, alignSelf:'stretch', color:Colors.text1, justifyContent:'center', alignItems:'center', backgroundColor:Colors.background2LoadingBackground}}>
		      				<Spinner color={ModalColors.border} />
		      			</View>
		      		: null
		      	}

		      	</View>
		      	<Button onPress={()=>
		  		{
		  			pop(self);
		  		}} type={1} colors={ButtonColors} style={{alignSelf:'stretch', margin:12}}>
				  	<Loc locKey="CANCEL_BUTTON"></Loc>
		      	</Button>
	      	</View>
      	}
      </PageContainer>
    );
  }
}
